export const InspectorWarning = ({ children }) => {
    return (
        <span className="workflow-editor-element-inspector__warning">
            {children}
        </span>
    );
};

export default InspectorWarning;
